import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './BusinessCard.css';

const BusinessCard = ({ business, onContact, onViewDetails }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
const [showCallPopup, setShowCallPopup] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  // const handlePrimaryAction = () => {
  //   onContact('call', business.phone, business);
  // };

  const handleSecondaryAction = (action) => {
    onContact(action, business[action === 'email' ? 'email' : 'website'], business);
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    
    return (
      <span className="rating-stars">
        {Array(fullStars).fill('⭐').join('')}
        {hasHalfStar && '⭐'}
        {Array(emptyStars).fill('☆').join('')}
      </span>
    );
  };

  return (
    <article className="business-card" data-verified={business.verified}>
      {/* Card Header - Image + Quick Actions */}
      <div className="card-header">
        <div className="business-image">
          {!imageError ? (
            <img
              src={business.image}
              alt={business.name}
              onLoad={handleImageLoad}
              onError={handleImageError}
              style={{ opacity: imageLoaded ? 1 : 0 }}
            />
          ) : (
            <div className="image-placeholder">
              <span className="placeholder-icon">📸</span>
            </div>
          )}
          
          {/* Overlay Badges */}
          <div className="image-overlay">
            {business.verified && (
              <span className="verified-badge">✓ Verified</span>
            )}
            {business.featured && (
              <span className="featured-badge">⭐ Featured</span>
            )}
          </div>
        </div>

        {/* Quick Action Buttons */}
       
          <button
            className="quick-action-btn primary"
            onClick={() => setShowCallPopup(true)}
            title="Call Business"
          >
            <span className="action-icon">📞</span>
          </button>
          <button
            className="quick-action-btn secondary"
            onClick={() => handleSecondaryAction('email')}
            title="Send Email"
          >
            <span className="action-icon">✉️</span>
          </button>
        
      </div>

      {/* Card Body - Business Information */}
      <div className="card-body">
        {/* Business Title & Rating */}
        <div className="business-title-section">
          <div className="title-row">
            <h3 className="business-name">{business.name}</h3>
            {/* <span className="price-range">{business.priceRange}</span> */}
          </div>
          
          <div className="rating-section">
            {renderStars(business.rating)}
            <span className="rating-value">{business.rating}</span>
            <span className="rating-count">({business.reviews})</span>
            {business.verified && <span className="verified-text">Verified</span>}
          </div>
        </div>

        {/* Business Description */}
        <p className="business-description">
          {business.description}
        </p>

        {/* Key Information */}
        <div className="business-info">
          <div className="info-row">
            <span className="info-icon">📍</span>
            <span className="info-text">{business.address}</span>
          </div>
          
          <div className="info-row">
            <span className="info-icon">🕐</span>
            <span className="info-text">{business.hours}</span>
          </div>
        </div>

        {/* Service Tags */}
        <div className="service-tags">
          {business.delivery && (
            <span className="service-tag delivery">🚚 Delivery</span>
          )}
          {business.takeaway && (
            <span className="service-tag takeaway">🥡 Takeaway</span>
          )}
          {business.reservation && (
            <span className="service-tag reservation">📅 Reservation</span>
          )}
        </div>

        {/* Features */}
        {business.features && (
          <div className="features-section">
            <div className="features-grid">
              {business.features.map((feature, index) => (
                <span key={index} className="feature-tag">
                  {feature}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Card Footer - Primary Actions */}
     {/* Card Footer - Primary Actions */}
{/* Card Footer - Primary Actions */}
<div className="card-footer">
  {/* All-in-one Action Row */}
  <div className="quick-contact-row">
   <button 
  className="contact-action-btn call" 
  onClick={() => setShowCallPopup(true)}
  title="Call Business"
>
  <span className="contact-icon"><i className="ri-phone-fill"></i></span>
  <span>Call</span>
</button>

    
    <button 
      className="contact-action-btn email" 
      onClick={() => handleSecondaryAction('email')}
      title="Send Email"
    >
      <span className="contact-icon"><i className="ri-mail-line"></i></span>
      <span>Email</span>
    </button>
    
    <button 
      className="contact-action-btn details" 
      onClick={() => onViewDetails(business)}
      title="View Full Details"
    >
      <span className="contact-icon"><i className="ri-file-info-line"></i></span>
      <span>Details</span>
    </button>
  </div>

  {/* Website Button */}
  <button 
    className="secondary-action-btn" 
    onClick={() => handleSecondaryAction('website')}
  >
    <span className="btn-icon"><i className="ri-global-line"></i></span>
    Visit Website
  </button>
</div>
{showCallPopup && (
  <div className="call-popup-overlay" onClick={() => setShowCallPopup(false)}>
    <div className="call-popup" onClick={(e) => e.stopPropagation()}>
      <button
        className="call-popup-close"
        onClick={() => setShowCallPopup(false)}
        aria-label="Close"
      >
        ✕
      </button>

      <div className="call-popup-icon">
        <i className="ri-phone-fill"></i>
      </div>

      <h4 className="call-popup-title">Call Business</h4>

      <a
        href={`tel:${business.phone}`}
        className="call-popup-number"
      >
        {business.phone}
      </a>

      <div className="call-popup-actions">
        <button
          className="call-popup-cancel"
          onClick={() => setShowCallPopup(false)}
        >
          Cancel
        </button>

        <a
          href={`tel:${business.phone}`}
          className="call-popup-confirm"
          onClick={() => {
            setShowCallPopup(false);
            onContact('call', business.phone, business);
          }}
        >
          Call Now
        </a>
      </div>
    </div>
  </div>
)}

    </article>
  );
};

BusinessCard.propTypes = {
  business: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    reviews: PropTypes.number.isRequired,
    phone: PropTypes.string.isRequired,
    email: PropTypes.string,
    website: PropTypes.string,
    address: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    priceRange: PropTypes.string,
    verified: PropTypes.bool,
    featured: PropTypes.bool,
    delivery: PropTypes.bool,
    takeaway: PropTypes.bool,
    reservation: PropTypes.bool,
    hours: PropTypes.string,
    features: PropTypes.array
  }).isRequired,
  onContact: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func.isRequired
};

export default BusinessCard;
